<template src="./template.html" />
<script>

import DetailPage from 'src/modules/pages/detail-page'
export default {
  name: 'StaffDetail',
  components: {
    'DetailPage': DetailPage
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      scaffolding: {
        items: {
          'item-1': {
            type: 'Collumns',
            fieldName: '{this.root}',
            leftRightMode: true,
            readonly: this.readonly,
            css: [`col-12 col-md-2 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-5 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-5 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
            colBody: [
              {
                'item-1': {
                  type: 'Avatar',
                  fieldName: 'avatar'
                },
                'item-2': {
                  type: 'Label',
                  fieldName: 'departments',
                  format: `(this.R.path(['value', 'bu', 'label'], this) || '')`,
                  class:'text-bold',
                  wrapperClass: 'text-center'
                },
                'item-3': {
                  type: 'Label',
                  fieldName: 'departments',
                  format: `(this.R.path(['value', 'dep', 'label'], this) || '')`,
                  class:'text-bold',
                  wrapperClass: 'text-center'
                },
                'item-4': {
                  type: 'Label',
                  label: 'HR trực tiếp',
                  fieldName: 'company',
                  format: `(this.R.path(['value', 'mainHR', 'name'], this) || '') + '  ' + (this.R.path(['value', 'mainHR', 'email'], this) || '')`,
                  wrapperClass: 'text-center'
                }
              },
              {
                'item-1': {
                  type: 'TextField',
                  label: 'Mã số NV',
                  validation: 'required',
                  fieldName: 'staffID',
                  clearable: true,
                  icon: 'account_box'
                },
                'item-2': {
                  type: 'Select',
                  label: 'Công ty',
                  validation: 'required',
                  fieldName: 'company',
                  clearable: true,
                  icon: 'account_balance',
                  datasource: {
                    options: [
                    ],
                    label: 'label',
                    value: 'value'
                  },
                  sortBy: 'label'
                },
                'item-3': {
                  type: 'TextField',
                  label: 'Email công ty',
                  fieldName: 'companyEmail',
                  clearable: true,
                  icon: 'email',
                  validation: 'email'
                },
                'item-4': {
                  type: 'Select',
                  label: 'Trạng thái làm việc',
                  validation: 'required',
                  fieldName: 'workingStatus',
                  icon: 'how_to_reg',
                  datasource: {
                    options: [
                      
                    ],
                    label: 'label',
                    value: 'value'
                  },
                  clearable: true
                }
              },
              {
                'item-1': {
                  type: 'TextField',
                  label: 'Họ tên',
                  validation: 'required',
                  fieldName: 'name',
                  clearable: true,
                  icon: 'people'
                },
                'item-2': {
                  type: 'Select',
                  label: 'Giới tính',
                  validation: 'required',
                  fieldName: 'gender',
                  clearable: true,
                  icon: 'people',
                  mapOptions: true,
                  datasource: {
                    options: [
                      {
                        label: 'Nam',
                        value: true
                      },
                      {
                        label: 'Nữ',
                        value: false
                      }
                    ],
                    label: 'label',
                    value: 'value',
                    emitValue: true
                  }
                },
                'item-3': {
                  type: 'TelInput',
                  fieldName: 'tel',
                  label: 'Số điện thoại'
                },
                'item-4': {
                  type: 'DatePicker',
                  label: 'Ngày làm việc sau cùng',
                  fieldName: 'lastWorkingDate',
                  clearable: true
                }
              }
            ]
          },
          'item-2': {
            type: 'Container',
            fieldName: 'personalInfo',
            items: {
              'item-1': {
                type: 'Collapse',
                label: 'Thông tin cá nhân',
                icon: 'people',
                fieldName: '{this.root}',
                defaultOpened: true,
                readonly: this.readonly,
                items: {
                  'item-1': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
                    colBody: [
                      {
                        'item-1': {
                          type: 'DatePicker',
                          label: 'Ngày sinh',
                          fieldName: 'birthday',
                          validation: 'required'
                        },
                        'item-2': {
                          type: 'TextField',
                          label: 'Nơi sinh/Nguyên quán',
                          fieldName: 'birth-place',
                          clearable: true,
                          icon: 'house'
                        },
                        'item-3': {
                          type: 'TextField',
                          label: 'Quốc tịch',
                          fieldName: 'nationality',
                          clearable: true,
                          icon: 'emoji_flags'
                        },
                        'item-4': {
                          type: 'TextField',
                          label: 'Email cá nhân',
                          fieldName: 'personalEmail',
                          clearable: true,
                          icon: 'email',
                          validation: 'email'
                        },
                        'item-5': {
                          type: 'TextField',
                          label: 'Mã số định danh',
                          fieldName: 'citizenID',
                          clearable: true,
                          icon: 'picture_in_picture',
                          validation: 'required'
                        },
                        'item-6': {
                          type: 'TextField',
                          label: 'Nơi cấp',
                          fieldName: 'issuedBy',
                          clearable: true,
                          icon: 'room',
                          validation: 'required'
                        },
                        'item-7': {
                          type: 'TextField',
                          label: 'Địa chỉ thường trú',
                          fieldName: 'homeAddress',
                          clearable: true,
                          icon: 'room',
                          validation: 'required'
                        }
                      },
                      {
                        'item-1': {
                          type: 'TextField',
                          label: 'Dân tộc',
                          fieldName: 'nation',
                          icon: 'flag',
                          clearable: true
                        },
                        'item-2': {
                          type: 'TextField',
                          label: 'Tôn giáo',
                          fieldName: 'religion',
                          icon: 'fas fa-church',
                          clearable: true
                        },
                        'item-3': {
                          type: 'Select',
                          label: 'Loại giấy tờ tuỳ thân',
                          clearable: true,
                          validation: 'required',
                          datasource: {
                            options: [],
                            label: 'label',
                            value: 'value'
                          },
                          icon: 'perm_identity',
                          fieldName: 'identityType'
                        },
                        'item-4': {
                          type: 'DatePicker',
                          label: 'Ngày cấp',
                          clearable: true,
                          validation: 'required',
                          fieldName: 'dateIssue'
                        },
                        'item-5': {
                          type: 'Select',
                          label: 'Tình trạng hôn nhân',
                          datasource: {
                            options: [
                              {
                                value: 'maried',
                                label: 'Đã lập gia đình'
                              },
                              {
                                value: 'notmaried',
                                label: 'Độc thân'
                              }
                            ],
                            label: 'label',
                            value: 'value'
                          },
                          fieldName: 'maritalStatus',
                          icon: 'fas fa-ring',
                          clearable: true
                        },
                        'item-6': {
                          type: 'TextField',
                          label: 'Địa chỉ tạm trú',
                          fieldName: 'temporaryAddress',
                          clearable: true,
                          icon: 'room'
                        }
                      }
                    ]
                  }
                }
              }
            }
          },
          'item-3': {
            type: 'Collapse',
            label: 'Hồ sơ nhân sự',
            icon: 'note',
            fieldName: '{this.root}',
            readonly: this.readonly,
            items: {
              'item-1': {
                type: 'Uploader',
                fieldName: 'personalDocumentList',
                accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt',
                maxFileSize: 10485760,
                label: 'Hồ sơ nhân sự',
                class: 'q-px-md',
                header: [
                  {
                    label: 'Loại giấy tờ',
                    format: 'file.documentType.label'
                  },
                  {
                    label: 'Tên file',
                    format: 'file.name'
                  },
                  {
                    format: 'file.hasOwnProperty(\'uploadDate\') ? this.convertDate(file.uploadDate) : \'\'',
                    label: 'Ngày tải lên'
                  }
                ],
                dialogScaffolding: {
                  'item-1': {
                    type: 'FileInput',
                    fieldName: 'file',
                    validation: 'required',
                    accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt'
                  },
                  'item-2': {
                    type: 'Select',
                    fieldName: 'documentType',
                    validation: 'required',
                    label: 'Loại hồ sơ',
                    datasource: {
                      options: [
                        {
                          label: 'Sơ yếu lý lịch tự thuật',
                          value: 'cv'
                        },
                        {
                          label: 'Giấy tờ tùy thân',
                          value: 'idPapers'
                        },
                        {
                          label: 'Giấy khai sinh',
                          value: 'birthCertificate'
                        },
                        {
                          label: 'Sổ hộ khẩu',
                          value: 'householdBook'
                        },
                        {
                          label: 'Bằng cấp/Chứng chỉ',
                          value: 'degree'
                        },
                        {
                          label: 'Giấy khám sức khỏe',
                          value: 'medical'
                        },
                        {
                          label: 'Quyết định thôi việc tại công ty cũ',
                          value: 'resignation'
                        }
                      ],
                      value: 'value',
                      label: 'label'
                    },
                    sortby: 'label',
                    clearable: true
                  }
                }
              }
            }
          },
          'item-4': {
            type: 'Container',
            fieldName: 'departments',
            items: {
              'item-1': {
                type: 'Collapse',
                label: 'Phòng ban bộ phận',
                icon: 'fas fa-building',
                fieldName: '{this.root}',
                readonly: this.readonly,
                items: {
                  'item-1': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
                    colBody: [
                      {
                        'dep': {
                          type: 'Select',
                          label: 'Phòng',
                          fieldName: 'dep',
                          validation: 'required',
                          datasource: {
                            options: [],
                            label: 'name',
                            value: 'id'
                          },
                          sortBy: 'name',
                          clearable: true,
                          onInput: this.changeDep
                        },
                        'item-2': {
                          type: 'Select',
                          label: 'Cấp bậc',
                          fieldName: 'level',
                          validation: 'required',
                          datasource: {
                            options: [
                              
                            ],
                            label: 'label',
                            value: 'value'
                          },
                          sortBy: 'label',
                          clearable: true,
                          icon: 'fas fa-level-up-alt'
                        },
                        'item-3': {
                          type: 'Select',
                          datasource: {
                            options: [],
                            value: 'value',
                            label: 'label'
                          },
                          label: 'Hình thức lao động',
                          validation: 'required',
                          fieldName: 'workType',
                          clearable: true,
                          icon: 'fas fa-briefcase'
                        },
                        'item-4': {
                          type: 'TextField',
                          label: 'Email người quản lý trực tiếp',
                          fieldName: 'managerEmail',
                          clearable: true,
                          icon: 'email',
                          validation: 'email'
                        },
                        'item-5': {
                          type: 'DatePicker',
                          label: 'Ngày làm việc đầu tiên',
                          fieldName: 'firstDayWork',
                          validation: 'required',
                          clearable: true
                        },
                      },
                      {
                        'item-1': {
                          type: 'Select',
                          label: 'Ban/Bộ phận',
                          fieldName: 'div',
                          // validation: 'required',
                          datasource: {
                            options: [],
                            label: 'name',
                            value: 'id'
                          },
                          sortBy: 'label',
                          readonly: true,
                          clearable: true,
                        },
                        'item-2': {
                          type: 'TextField',
                          label: 'Chức danh',
                          validation: 'required',
                          fieldName: 'title',
                          icon: 'fas fa-briefcase',
                          clearable: true
                        },
                        'item-3': {
                          type: 'TextField',
                          label: 'Họ tên người quản lý trực tiếp',
                          validation: 'required',
                          fieldName: 'nameDirectManager',
                          icon: 'fas fa-id-card-alt',
                          clearable: true
                        },
                        'item-4': {
                          type: 'TextField',
                          label: 'Thâm niên',
                          fieldName: 'seniority',
                          icon: 'fas fa-user-clock',
                          clearable: true
                        },
                        'item-5': {
                          type: 'Checkbox',
                          label: 'Tham gia Công đoàn',
                          fieldName: 'joinUnio'
                        }
                      }
                    ]
                  }
                }
              }
            }
          },
          'item-5': {
            type: 'Container',
            fieldName: 'qualification',
            items: {
              'item-1': {
                type: 'Collapse',
                label: 'Trình độ chuyên môn',
                icon: 'fas fa-graduation-cap',
                readonly: this.readonly,
                fieldName: '{this.root}',
                items: {
                  'item-1': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
                    colBody: [
                      {
                        'item-1': {
                          type: 'Select',
                          label: 'Bằng cấp/Học vị',
                          fieldName: 'degree',
                          icon: 'fas fa-user-graduate',
                          datasource: {
                            options: [
                              
                            ],
                            label: 'label',
                            value: 'value'
                          },
                          clearable: true
                        },
                        'item-2': {
                          type: 'TextField',
                          label: 'Chuyên ngành đào tạo',
                          fieldName: 'specialized',
                          icon: 'fas fa-user-tag',
                          clearable: true
                        }
                      },
                      {
                        'item-1': {
                          type: 'TextField',
                          label: 'Nơi đào tạo',
                          fieldName: 'school',
                          icon: 'fas fa-school',
                          clearable: true
                        },
                        'item-2': {
                          type: 'NumberField',
                          label: 'Năm tốt nghiệp',
                          fieldName: 'graduationYear',
                          icon: 'fas fa-graduation-cap',
                          clearable: true
                        }
                      }
                    ]
                  }
                }
              }
            }
          },
          'item-6': {
            type: 'Container',
            fieldName: 'family',
            items: {
              'item-1': {
                type: 'Collapse',
                label: 'Quan hệ gia đình',
                icon: 'fas fa-heart',
                fieldName: '{this.root}',
                readonly: this.readonly,
                items: {
                  'item-1': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
                    colBody: [
                      {
                        'item-1': {
                          type: 'TextField',
                          label: 'Họ tên người liên hệ trong trường hợp khẩn cấp',
                          fieldName: 'namePersonToContact',
                          icon: 'fas fa-user-tie',
                          clearable: true
                        },
                        'item-2': {
                          type: 'TextField',
                          label: 'Địa chỉ liên hệ khẩn cấp',
                          fieldName: 'address',
                          icon: 'fas fa-map-marker',
                          clearable: true
                        },
                        'item-3': {
                          type: 'TextField',
                          label: 'Con thứ nhất',
                          fieldName: 'firstChild',
                          icon: 'fas fa-user-tie',
                          hint: `Nhập theo cấu trúc: Họ tên/Giới tinh (G/B - Girl/Boy)/Năm sinh VD: Nguyễn Thị A/G/2012`,
                          clearable: true
                        },
                        'item-4': {
                          type: 'TextField',
                          label: 'Con thứ ba',
                          fieldName: 'thirdChild',
                          icon: 'fas fa-user-tie',
                          hint: `Nhập theo cấu trúc: Họ tên/Giới tinh (G/B - Girl/Boy)/Năm sinh VD: Nguyễn Thị A/G/2012`,
                          clearable: true
                        },
                        'item-5': {
                          type: 'NumberField',
                          label: 'Số lượng người phụ thuộc',
                          fieldName: 'numDepentPerson',
                          validation: 'required',
                          icon: 'people',
                          clearable: true
                        }
                      },
                      {
                        'item-1': {
                          type: 'TextField',
                          label: 'Quan hệ',
                          fieldName: 'relation',
                          icon: 'fas fa-user-tie',
                          clearable: true
                        },
                        'item-2': {
                          type: 'TelInput',
                          fieldName: 'tel',
                          label: 'Số điện thoại liên hệ khẩn cấp'
                        },
                        'item-3': {
                          type: 'TextField',
                          label: 'Con thứ hai',
                          fieldName: 'secondChild',
                          icon: 'fas fa-user-tie',
                          hint: `Nhập theo cấu trúc: Họ tên/Giới tính (G/B - Girl/Boy)/Năm sinh VD: Nguyễn Thị A/G/2012`,
                          clearable: true
                        },
                        'item-4': {
                          type: 'TextField',
                          label: 'Con thứ tư',
                          fieldName: 'fourthChild',
                          icon: 'fas fa-user-tie',
                          hint: `Nhập theo cấu trúc: Họ tên/Giới tính (G/B - Girl/Boy)/Năm sinh VD: Nguyễn Thị A/G/2012`,
                          clearable: true
                        }
                      }
                    ]
                  }
                }
              }
            }
          }
        }
      },
      isLoading: true,
      isSubmiting: false,
      backLink: {
        name: '/human-resources/staff-information',
        path: '/human-resources/staff-information'
      },
      queryPath: ['StaffInformation', this.id ? this.id : this.$route.query.id ? this.$route.query.id : null],
      baseData: this.mode && this.mode === 'CREATE' ? {} : this.data,
      masterdata: null
    }
  },
  computed: {
    computeScaffolding() {
      let newScaffolding = this.scaffolding
      if(this.masterdata) {
        newScaffolding.items['item-4'].items['item-1'].items['item-1'].colBody[0]['dep'].datasource.options = this.masterdata.listDep.filter(item => item.buID === 'natb')
        newScaffolding.items['item-4'].items['item-1'].items['item-1'].colBody[1]['item-1'].datasource.options = 
        this.masterdata.listDivision.filter(item => item.depID === this._.get(this.baseData, ['departments', 'dep', 'id']))
        newScaffolding.items['item-4'].items['item-1'].items['item-1'].colBody[0]['item-2'].datasource.options = this.masterdata.listLevel
        newScaffolding.items['item-4'].items['item-1'].items['item-1'].colBody[0]['item-3'].datasource.options = this.masterdata.listWorkingType
        newScaffolding.items['item-1'].colBody[1]['item-2'].datasource.options = this.masterdata.listCompany
        newScaffolding.items['item-1'].colBody[1]['item-4'].datasource.options = this.masterdata.listWorkingStatus
        newScaffolding.items['item-2'].items['item-1'].items['item-1'].colBody[1]['item-3'].datasource.options = this.masterdata.listIdentityType
        newScaffolding.items['item-5'].items['item-1'].items['item-1'].colBody[0]['item-1'].datasource.options = this.masterdata.listDegree
      }
      return newScaffolding
    }
  },
  async mounted () {
    if(this.readonly && this.mode === 'CREATE' && this.$route.path === '/human-resources/staff-information') {
      await this.fetchDataOnCurrentUser()
    }
    this.fetchMasterData()
    this.isLoading = false
  },
  methods: {
    fetchDataOnCurrentUser() {
      let vm = this
      if(this.R.path(['getters', 'user', 'email'], this.$store)) {
        return this.$query(['StaffInformation'], [['companyEmail', '==', this.R.path(['getters', 'user', 'email'], this.$store)]]).then(res => {
          if(res.data.length > 0) {
            vm.baseData = res.data[0]
            vm.$refs.detailPage.$emit('onUpdateData', vm.baseData)
          }
        })
      }
    },
    fetchMasterData() {
      this.$query(['MasterData', 'HRMasterData']).then(res => {
        this.masterdata = res
      })
    },
    async handlerSubmit (payload, resolve, reject) {
      let vm = this
      console.log('handlerSubmit', payload.data)
      let submitModel = { id: payload.id, data: payload.data }
      await vm.$command.execute('updateStaffInformation', submitModel).then(res => resolve(res)).catch(err => reject(err))
    },
    detailPageFetched (data) {
     this.baseData = data
    },
    changeBU(value) {
      this.computeScaffolding.items['item-4'].items['item-1'].items['item-1'].colBody[1]['item-1'].datasource.options = 
      this.masterdata.listDep.filter(item => item.buID === value.value)
    },
    changeDep(val) {
      if (val) {
        let options = this.masterdata.listDivision.filter(item => item.depID === val.id)
        this.computeScaffolding.items['item-4'].items['item-1'].items['item-1'].colBody[1]['item-1'].datasource.options = options
        if (options.length > 0) this.computeScaffolding.items['item-4'].items['item-1'].items['item-1'].colBody[1]['item-1'].readonly = false
      }
      else {
        this.computeScaffolding.items['item-4'].items['item-1'].items['item-1'].colBody[1]['item-1'].datasource.options = []
        this.computeScaffolding.items['item-4'].items['item-1'].items['item-1'].colBody[1]['item-1'].readonly = true
      }
    }
  }
}
</script>
